import { useEffect, useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import axios from 'axios';

export default function WhatsAppWidget() {
  const [whatsapp, setWhatsapp] = useState('');

  useEffect(() => {
    axios.get('/api/settings').then(r => setWhatsapp(r.data.whatsapp_number || '')).catch(() => {});
  }, []);

  if (!whatsapp) return null;

  return (
    <a
      href={`https://wa.me/${whatsapp}`}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-6 z-40 group flex items-center gap-3"
      aria-label="WhatsApp ile yazın"
    >
      <span className="hidden group-hover:flex items-center bg-white text-gray-700 text-sm font-medium px-4 py-2 rounded-full shadow-lg whitespace-nowrap border border-gray-100">
        WhatsApp ile Yaz
      </span>
      <div className="relative w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-xl transition-all duration-200 hover:scale-110">
        <FaWhatsapp className="text-white text-2xl" />
        <span className="absolute -top-1 -right-1 w-4 h-4 bg-green-400 rounded-full animate-ping opacity-75" />
      </div>
    </a>
  );
}
